<template>
  <div
    v-loading.fullscreen.lock="fullScreenLoading"
    element-loading-text="loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <vxe-grid
      ref="table"
      highlight-hover-row
      :data="tableData"
      :toolbar-config="tableToolbar"
      :columns="tableColumns"
      :row-class-name="rowClassName"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      row-id="waybillDetailCode"
      :checkboxConfig="{
        reserve: true,
        highlight: false,
      }"
      auto-resize
    >
      >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:orderso="{ row }">
        <div>
          <span>{{ row.orderSoNo ? row.orderSoNo : '--' }}</span>
        </div>
      </template>
      <!-- <template v-slot:defaultIsAbnormal="{ row }">
        <span v-if="row.v_isAbnormal === '异常'" style="color:red;">
          {{ row.v_isAbnormal }}
        </span>
        <span v-else>{{ row.v_isAbnormal }}</span>
      </template> -->
      <template v-slot:orderStatus="{ row }">
        <el-tag
          size="mini"
          :type="
            row.orderStatus === 'N'
              ? 'success'
              : row.orderStatus === 'Y'
              ? 'light'
              : 'warning'
          "
        >
          {{ row.orderStatusName }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            content="打印"
            v-allow="'actPrint'"
            placement="top"
          >
            <i
              class="el-icon-printer tool-btn"
              @click="detailPrint(row.waybillDetailCode)"
            ></i>
          </el-tooltip>

          <el-dropdown
            trigger="click"
            @command="(command) => onOptClick(command, row)"
          >
            <el-tooltip
              class="item"
              effect="dark"
              content="更多"
              placement="top"
            >
              <i class="el-icon-more el-icon--right  tool-btn"></i>
            </el-tooltip>

            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                command="isPickup"
                class="d-flex align-items-center"
                icon="el-icon-box tool-btn"
                v-allow="'actPickup'"
                v-if="row.bizStatus === '1'"
              >
                提货
              </el-dropdown-item>
              <el-dropdown-item
                command="isReceive"
                class="d-flex align-items-center"
                icon="el-icon-takeaway-box tool-btn"
                v-allow="'actReceive'"
                v-if="row.bizStatus === '2'"
              >
                送达
              </el-dropdown-item>
              <el-dropdown-item
                command="uploadPod"
                class="d-flex align-items-center"
                icon="el-icon-tickets tool-btn"
                v-allow="'actPod'"
                v-if="
                  row.bizStatus === '3' ||
                    row.bizStatus === '4' ||
                    row.bizStatus === '6'
                "
              >
                {{ row.bizStatus === '3' ? '上传回单' : '修改回单' }}
              </el-dropdown-item>

              <el-dropdown-item
                command="serviceFeedback"
                class="d-flex align-items-center"
                icon="el-icon-service tool-btn"
                v-allow="'actFeedback'"
              >
                客服反馈
              </el-dropdown-item>
              <el-dropdown-item
                command="exceptionRegister"
                class="d-flex align-items-center"
                icon="el-icon-warning-outline tool-btn"
                v-allow="'actException'"
              >
                异常登记
              </el-dropdown-item>
              <el-dropdown-item
                command="costReport"
                class="d-flex align-items-center"
                icon="el-icon-money tool-btn"
                v-allow="'actCost'"
              >
                费用上报
              </el-dropdown-item>
              <el-dropdown-item
                command="packing"
                class="d-flex align-items-center"
                icon="el-icon-files tool-btn"
                v-allow="'actBox'"
              >
                装箱
              </el-dropdown-item>
              <el-dropdown-item
                command="backfill"
                class="d-flex align-items-center"
                icon="el-icon-edit-outline tool-btn"
                v-allow="'actLoadBackfill'"
                v-if="row.bizStatus !== '7'"
              >
                装载信息回填
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:orderNo="{ row }">
        <div>
          <el-link type="primary" @click="openOrderDetailPage(row.orderNo)">
            {{ row.orderNo }}
          </el-link>
        </div>
      </template>
    </vxe-grid>
    <set-pickup
      :selectList="selectList"
      :selectDispatchNoList="selectDispatchNoList"
      @comitOk="comitOk()"
      v-if="showPickupCommitForm"
    />
    <set-receive
      :selectList="selectList"
      :selectDispatchNoList="selectDispatchNoList"
      @comitOk="comitOk()"
      v-if="showReceiveCommitForm"
    />
    <el-dialog
      v-if="visible"
      v-el-dialog-drag
      show-close
      visible
      width="800px"
      title="上传POD回单"
      top="10vh"
      :close-on-click-modal="false"
      :before-close="() => $refs.podForm.cancel()"
    >
      <pod-form
        ref="podForm"
        :params="params"
        @close="visible = false"
        @reload="comitOk()"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.podForm.cancel()">取消</el-button>
        <el-button type="primary" size="small" @click="$refs.podForm.save()"
          >确认</el-button
        >
      </span>
    </el-dialog>

    <feedback-dialog :visible.sync="feedbackDialogvisible" :params="params" />
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import SetPickup from '../to-pick-table/set-pickup.vue'
import SetReceive from '../to-delivery-table/set-receive.vue'
import PodForm from '../to-pod-table/pod-from.vue'
import FeedbackDialog from '../feedback/feedback-dialog'
export default {
  components: { SetPickup, SetReceive, PodForm, FeedbackDialog },
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      tableColumns: tableColumns(),
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      fullScreenLoading: false,
      selectList: [],
      selectDispatchNoList: [],
      selectStatusList: [],
      showPickupCommitForm: false,
      showReceiveCommitForm: false,
      visible: false,

      // feedbackDialogOptions: {
      //   visible: false,
      // },
      codeList: [],
      feedbackDialogvisible: false,
      params: {},
      rowClassName: ({ row }) => {
        if (row.v_isAbnormal === '异常') {
          return 'bg-danger text-white'
        }
        return ''
      },
    }
  },
  methods: {
    onOptClick(command, row) {
      this[command](row)
    },
    getHeight() {
      this.tableHeight = window.innerHeight - 204
    },
    isPickup(row) {
      this.showPickupCommitForm = false
      this.showReceiveCommitForm = false
      this.selectList = []
      this.selectList.push(row.waybillDetailCode)
      this.selectDispatchNoList = []
      this.selectDispatchNoList.push(row.dispatchOrderNo)
      this.showPickupCommitForm = true
    },
    //批量提货
    async batchIsPickup() {
      this.showPickupCommitForm = false
      this.showReceiveCommitForm = false
      const selectStauts = await this.getSelectStauts('待提货')
      const selectCode = await this.getSelectData('code')
      if (!selectCode) {
        return
      }
      if (!selectStauts) {
        return
      }
      this.showPickupCommitForm = true
    },
    isReceive(row) {
      this.showPickupCommitForm = false
      this.showReceiveCommitForm = false
      this.selectList = [
        {
          waybillDetailCode: row.waybillDetailCode,
          dispatchOrderNo: row.dispatchOrderNo,
        },
      ]
      this.showReceiveCommitForm = true
    },
    //批量送达
    async batchIsReceive() {
      this.showPickupCommitForm = false
      this.showReceiveCommitForm = false
      const selectStauts = await this.getSelectStauts('待送达')
      const selectCode = await this.getSelectData()
      if (!selectCode) {
        return
      }
      if (!selectStauts) {
        return
      }
      this.selectList = this.selectList.map((item) => ({
        waybillDetailCode: item.waybillDetailCode,
        dispatchOrderNo: item.dispatchOrderNo,
      }))
      this.showReceiveCommitForm = true
    },
    comitOk() {
      this.showPickupCommitForm = false
      this.showReceiveCommitForm = false
      this.$refs.table.clearCheckboxRow()
      this.$refs.table.clearCheckboxReserve()
      this.$emit('reload')
    },
    getSelectData(selectType) {
      // 缓存的选中数据，非当前页数据
      let reserveRecords = this.$refs.table.getCheckboxReserveRecords()
      // 当前页选中的数据
      let selectRecords = this.$refs.table.getCheckboxRecords()
      let totCount = reserveRecords.length + selectRecords.length
      if (totCount === 0) {
        this.$message.warning('请选择需要批量处理的单据')
        return false
      }
      this.selectList = []
      this.selectDispatchNoList = []
      // 将缓存中的选中数据，加入已选中数据列表
      if (reserveRecords.length > 0) {
        reserveRecords.forEach((row) => {
          if (selectType == 'code') {
            this.selectList.push(row.waybillDetailCode)
            this.selectDispatchNoList.push(row.dispatchOrderNo)
          } else {
            this.selectList.push(row)
          }
        })
      }
      // 将当前页选中数据，加入已选中数据列表
      if (selectRecords.length > 0) {
        selectRecords.forEach((row) => {
          if (selectType == 'code') {
            this.selectList.push(row.waybillDetailCode)
            this.selectDispatchNoList.push(row.dispatchOrderNo)
          } else {
            this.selectList.push(row)
          }
        })
      }
      if (totCount > 20) {
        this.$message.warning('每次批量选择单价数量，不能超过20张')
        return false
      }
      return true
    },

    //批量打印使用
    getPrintSelectData() {
      // 缓存的选中数据，非当前页数据
      let reserveRecords = this.$refs.table.getCheckboxReserveRecords()
      // 当前页选中的数据
      let selectRecords = this.$refs.table.getCheckboxRecords()
      let totCount = reserveRecords.length + selectRecords.length
      if (totCount === 0) {
        this.$message.warning('请选择需要批量处理的数据')
        return false
      }
      this.codeList = []
      // 将缓存中的选中数据，加入已选中数据列表
      if (reserveRecords.length > 0) {
        reserveRecords.forEach((row) => {
          this.codeList.push(row.waybillDetailCode)
        })
      }
      // 将当前页选中数据，加入已选中数据列表
      if (selectRecords.length > 0) {
        selectRecords.forEach((row) => {
          this.codeList.push(row.waybillDetailCode)
        })
      }
      if (totCount > 20) {
        this.$message.warning('每次批量选择的数据数量，不能超过20条')
        return false
      }
      return true
    },

    getSelectStauts(selectStauts) {
      // 缓存的选中数据，非当前页数据
      let reserveRecords = this.$refs.table.getCheckboxReserveRecords()
      // 当前页选中的数据
      let selectRecords = this.$refs.table.getCheckboxRecords()
      let totCount = reserveRecords.length + selectRecords.length
      this.selectStatusList = []
      if (selectStauts === '待提货') {
        // 将缓存中的选中数据，加入已选中数据列表
        if (reserveRecords.length > 0) {
          reserveRecords.forEach((row) => {
            if (row.v_bizStatus != '待提货') {
              this.selectStatusList.push(row.v_bizStatus)
            }
          })
        }
        // 将当前页选中数据，加入已选中数据列表
        if (selectRecords.length > 0) {
          selectRecords.forEach((row) => {
            if (row.v_bizStatus != '待提货') {
              this.selectStatusList.push(row.v_bizStatus)
            }
          })
        }
        if (this.selectStatusList.length > 0) {
          this.$message.warning('选择单据中存在非待提货单据，请重新选择')
          return false
        }
      }
      if (selectStauts === '待送达') {
        // 将缓存中的选中数据，加入已选中数据列表
        if (reserveRecords.length > 0) {
          reserveRecords.forEach((row) => {
            if (row.v_bizStatus != '待送达') {
              this.selectStatusList.push(row.v_bizStatus)
            }
          })
        }
        // 将当前页选中数据，加入已选中数据列表
        if (selectRecords.length > 0) {
          selectRecords.forEach((row) => {
            if (row.v_bizStatus != '待送达') {
              this.selectStatusList.push(row.v_bizStatus)
            }
          })
        }
        if (this.selectStatusList.length > 0) {
          this.$message.warning('选择单据中存在非待送达单据，请重新选择')
          return false
        }
      }

      if (totCount > 20) {
        this.$message.warning('每次批量选择单价数量，不能超过20张')
        return false
      }
      return true
    },

    uploadPod(val) {
      this.params = val
      this.visible = true
    },

    getTableCheckedData(isNotEmpty) {
      const data = this.$refs.table
        .getCheckboxRecords()
        .concat(this.$refs.table.getCheckboxReserveRecords())
      if (isNotEmpty) {
        if (data === null || data === [] || data.length === 0) {
          this.$message({
            message: '请选择您要操作的数据！',
            type: 'warning',
          })
          return
        }
      }
      return data
    },
    batchExport() {
      const data = this.getTableCheckedData(true)
      if (!data) return

      this.$refs.table.exportData({
        filename: '所有订单单据' + Date.now(),
        type: 'csv',
        data: data,
        columnFilterMethod({ column }) {
          return !['col-opt', 'checkbox'].includes(column.property)
        },
      })
    },

    serviceFeedback(row) {
      this.feedbackDialogvisible = true
      this.params = row
    },
    exceptionRegister(row) {
      this.$emit('exceptionRegister', row)
    },
    packing(row) {
      this.$emit('packing', row)
    },
    backfill(row) {
      this.$emit('backfill', row)
    },
    costReport(row) {
      this.$emit('costReport', row)
    },
    // detailPrint(row) {
    //   this.$api.printPDF('/order/bizDispatchPool/print', {
    //     dispatchOrderCode: row.dispatchOrderCode
    //   })
    // }
    detailPrint(code) {
      this.codeList = []
      this.codeList.push(code)
      this.$api.printPDF('/order/waybill/detail/print', {
        waybillDetailCodeList: this.codeList,
      })
    },
    async batchDetailPrint() {
      const selectCode = await this.getPrintSelectData()
      if (!selectCode) {
        return
      }
      this.$api.printPDF('/order/waybill/detail/print', {
        waybillDetailCodeList: this.codeList,
      })
    },
    openOrderDetailPage(no) {
      this.$router.push({
        name: 'carriage-order-detail-page',
        params: { no },
      })
    },
  },
}
</script>
